import { AppShell } from '@mantine/core';
import { useViewportSize } from '@mantine/hooks';
import { Box, brand } from '@zorro/web/design-system';
import { ReactNode, forwardRef } from 'react';

import { useAppLayout } from '../AppLayoutContext';

type Props = {
  children: ReactNode;
  topLeftLabel?: string;
};

export const AppLayoutMain = forwardRef<HTMLDivElement, Props>(
  ({ children, topLeftLabel }: Props, ref) => {
    const { height: viewportHeight } = useViewportSize();
    const { isSidebarOpen } = useAppLayout();

    return (
      <AppShell.Main
        style={{
          height: `calc(${viewportHeight}px - var(--app-layout-header-height) - var(--app-layout-subheader-height))`,
        }}
      >
        <Box ref={ref} h={{ base: 'auto', sm: '100%' }}>
          {!isSidebarOpen && topLeftLabel && (
            <Box
              pos="absolute"
              left={0}
              top={0}
              bg={brand.zorroPlum200}
              p="0.375rem 2.5rem"
              fz={14}
              fw={400}
              style={{ borderBottomRightRadius: 16 }}
            >
              {topLeftLabel}
            </Box>
          )}
          <Box pos="relative">{children}</Box>
        </Box>
      </AppShell.Main>
    );
  }
);

AppLayoutMain.displayName = 'AppLayoutMain';
